import useCodonationAnalytics from './useCodonationAnalytics'
import useDonationFormContext from '@/donationPages/_dependencies/helpers/useDonationFormContext'
import useDonationFormValues from '@/donationPages/_dependencies/helpers/useDonationFormValues'
import { useCallback, useEffect, useRef, useState } from 'react'

function useCodonationValue() {
  const [codonationCents] = useDonationFormValues(['codonation_cents'])
  const { setValue: setFormValue } = useDonationFormContext()
  const valueRef = useRef(codonationCents)
  const [value, internalSetValue] = useState(codonationCents)
  const {
    commitHandler: commitAnalyticsState,
    reset: resetAnalyticsState,
    changeValue: changeAnalyticsValue,
  } = useCodonationAnalytics(codonationCents)
  const commitValue = useCallback(() => {
    setFormValue('codonation_cents', valueRef.current, {
      shouldTouch: true,
      shouldValidate: true,
      shouldDirty: true,
    })
    commitAnalyticsState()
  }, [setFormValue, commitAnalyticsState])

  const setValue = useCallback(
    (value: number) => {
      internalSetValue(value)
      changeAnalyticsValue(value)
      valueRef.current = value
    },
    [changeAnalyticsValue]
  )

  useEffect(() => {
    setValue(codonationCents)
  }, [codonationCents, setValue])

  const reset = useCallback(() => {
    setValue(codonationCents)
    resetAnalyticsState()
  }, [codonationCents, setValue, resetAnalyticsState])
  return [value, setValue, commitValue, reset] as const
}

export default useCodonationValue
